import { Box, Container, Link, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import AppDialog from "./AppDialog";
import Error from "../assets/logo/error-warning-line.svg";
import { useTranslation } from "react-i18next";
import config from "../utils/config";

const Blocked = () => {
  const blocked = useSelector(({ Auth }) => Auth?.blocked);
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));
  const { t } = useTranslation();
  return (
    <AppDialog
      show={blocked}
      showClose={false}
      fullScreen={false}
      sx={{
        ".MuiDialog-paper": {
          height: "45%",
          position: isLargeScreen ? "realtive" : "fixed",
          bottom: 0,
          borderRadius: isLargeScreen ? "24px 24px 24px 24px" : "24px 24px 0px 0px",
        },
      }}
    >
      <Container maxWidth="xs" sx={{ paddingTop: 10 }} >
        <Box
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          flexDirection="column"
        >
          <Error />
          <Typography
            color="#D4D4D8"
            fontSize={20}
            fontWeight={700}
            textAlign="center"
            marginTop={2}
          >
            {t("blockedTitle")}
          </Typography>
          <Typography
            color="#D4D4D8"
            fontSize={16}
            fontWeight={400}
            textAlign="center"
            marginTop={2}
          >
            {t("blockedSubtitle")}
          </Typography>
        </Box>
        <Box color="#D4D4D8" fontSize={16} marginTop={4} display='flex' justifyContent={'center'}>
          <Link href={config.ZENDESK_SUPPORT} target='_blank' textAlign="center"> {t("contact")} </Link>
        </Box>
      </Container>
    </AppDialog>
  );
};

export default Blocked;
